import { ArrowRight, Star } from "lucide-react";
import { BUSINESS, REVIEWS } from "../data/site";
import { scrollToId } from "../lib/scroll";
import { Reveal } from "./Reveal";

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-[#9fd3f0] text-[#9fd3f0]" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="bg-[#f6f7f9] py-20 sm:py-28">
    <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
      <Reveal>
        <h2 className="text-4xl font-black uppercase tracking-[-0.02em] text-[#161e2b] sm:text-5xl lg:text-6xl">
          REVIEWS
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#5c6675] md:text-lg">
          What clients across Calhoun are saying about Phade Barbers.
        </p>
      </Reveal>

      <div data-testid="reviews-grid" className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
        {REVIEWS.map((review, i) => (
          <Reveal key={review.name} delay={(i % 2) * 0.08} className="h-full">
            <figure
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col rounded-xl border border-[#e4e7ee] bg-white p-8 transition-shadow duration-300 hover:shadow-[0_18px_50px_-24px_rgba(12,18,32,0.25)]"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-[#3b4656]">
                &ldquo;{review.text}&rdquo;
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3.5 border-t border-[#eef0f4] pt-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#e3f1fb] text-base font-extrabold text-[#4a9bdc]">
                  {review.initial}
                </span>
                <span>
                  <span className="block text-sm font-bold text-[#161e2b]">{review.name}</span>
                  <span className="block text-xs text-[#8a93a3]">Google Review</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-12">
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            data-testid="reviews-choose-barber-button"
            onClick={() => scrollToId("barbers")}
            className="group inline-flex items-center gap-2.5 rounded-lg bg-[#4a9bdc] px-9 py-4 text-sm font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#5aaae8]"
          >
            CHOOSE YOUR BARBER
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <a
            data-testid="google-review-link"
            href={BUSINESS.googleReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2.5 rounded-lg border border-[#161e2b]/20 px-9 py-4 text-sm font-bold tracking-[0.08em] text-[#161e2b] transition-colors duration-300 hover:border-[#4a9bdc] hover:text-[#4a9bdc]"
          >
            <Star className="h-4 w-4 transition-transform duration-300 group-hover:scale-110" />
            LEAVE US A GOOGLE REVIEW
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
